import React, { Component } from 'react';
import { joinClasses } from 'components/utils/react_helper';
import Select, { components } from 'react-select';
import I18n, { translationListToSelectOptions } from '~/utils/translations';

export default class CancelViewing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      cancellationReason: null,
    };
  }

  handleCancelClick = () => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.props.handleViewingCancelled(this.state.cancellationReason);
      }
    );
  };

  render() {
    return (
      <div className="cancel-viewing">
        <hr className="cancel-viewing__divider" />

        <p className="cancel-viewing__title">{I18n.t('viewings.cancel_viewing.title')}</p>
        <p className="cancel-viewing__subheading">{this.rescheduleCopy}</p>

        <Select
          id="cancel-viewing-dropdown"
          options={this.renderCancellationOptions()}
          placeholder={I18n.t('viewings.cancel_viewing.dropdown.placeholder')}
          onChange={this.handleChange}
          styles={{
            option: (provided, state) => ({
              ...provided,
              textAlign: 'left',
              color: 'rgb(51, 51, 51)',
              backgroundColor: state.isFocused ? 'rgb(232, 232, 232)' : 'white',
            }),
          }}
        />

        {this.props.viewingCancelError && this.renderError()}

        <button type="submit" className={this.classes} disabled={this.state.loading} onClick={this.handleCancelClick}>
          {this.cancelCopy}
        </button>
      </div>
    );
  }

  renderCancellationOptions = () => {
    return translationListToSelectOptions(I18n.t('viewings.cancel_viewing.dropdown.reasons'));
  };

  handleChange = (e) => {
    this.setState({ cancellationReason: e.value });
  };

  renderError() {
    return (
      <div className="cancel-viewing-error">
        {I18n.t('viewings.cancel_viewing.error', { email: I18n.t('brand.email') })}
      </div>
    );
  }

  get cancellationReason() {
    return this.state.cancellationReason;
  }

  get classes() {
    return joinClasses(['cancel-viewing__button cancel-viewing__button--tertiary', this.state.loading && 'loading']);
  }

  get rescheduleCopy() {
    return this.props.property.requestViewingEnabled
      ? I18n.t('viewings.cancel_viewing.request_subheading')
      : I18n.t('viewings.cancel_viewing.subheading');
  }

  get cancelCopy() {
    return this.props.property.requestViewingEnabled
      ? I18n.t('viewings.cancel_viewing.request_button')
      : I18n.t('viewings.cancel_viewing.button');
  }
}
